export enum ELoginType {
  LOGIN_FROM_SSO = 'LoginFromSSO',
  LOGIN_OTP = 'LoginOTP',
  LOGIN_WITH_PWD = 'Login',
}
